<template>
    <div class="page-container">
        <div class="condition-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item>
                    <el-input v-model="queryParams.orderNo" clearable placeholder="请输入订单编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryParams.iccid" clearable placeholder="请输入ICCID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="rangeTime" type="daterange" value-format="yyyy-MM-dd" align="right"
                        unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="$dateQuickPickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="data-container">
            <el-table v-loading="loading" :data="list" stripe border>
                <div slot="empty">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <el-table-column prop="orderNo" label="订单编号"></el-table-column>
                <el-table-column prop="iccid" label="ICCID"></el-table-column>
                <el-table-column label="充值时长">
                    <template slot-scope="scope">
                        {{scope.row.year}} 年
                    </template>
                </el-table-column>
                <el-table-column label="充值金额">
                    <template slot-scope="scope">
                        {{scope.row.money}} 元
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="充值时间" width="180"></el-table-column>
                <el-table-column prop="simExpireTime" label="到期时间" width="150"></el-table-column>
            </el-table>
        </div>
        <div class="paging-container paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum" :page-sizes="$pageSizes" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>


<script>
var moment = require('moment');

export default {
    data() {
        return {
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                orderNo: null,
                iccid: null,
                beginTime: null,
                endTime: null
            },
            rangeTime: [],
            total: 0,
            list: []
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        let loginInfo = JSON.parse(loginInfoStr);
        let developer = loginInfo.developer;
        let token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },
    methods: {
        handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query(pageNum) {
            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            if (null != this.rangeTime && "" != this.rangeTime) {
                this.queryParams.beginTime = this.rangeTime[0];
                let endTime = this.rangeTime[1];
                endTime = moment(endTime + " 00:00:00").add(1, 'd').format("YYYY-MM-DD");
                this.queryParams.endTime = endTime;
            } else {
                this.queryParams.beginTime = null;
                this.queryParams.endTime = null;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listSimDeposit", {
                params: this.queryParams,
                headers: this.headers
            }).then(res => {
                this.loading = false;
                if (res.data.code == 200) {
                    this.total = res.data.total;
                    let result = res.data.rows;
                    result.forEach(element => {
                        let simExpireTime = element.simExpireTime;
                        element.simExpireTime = moment(simExpireTime).format("YYYY-MM-DD");
                    });
                    this.list = result;
                }
            });
        }
    }
}
</script>


<style scoped>
.page-container {
    height: 100%;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
}

.data-container {
    overflow-y: scroll;
}

.detail {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// deposit.vue?6884c90f